/*
  lb-kaufbox.js: Skript der Kaufbox auf der Starter-Kit-Vorlage, Stand 03.11.2026
  Geladen vom Teil assets in snippets/lb-kaufbox (defer), nach assets/lb-basis.js.
  Warenkorb-Leiste unten (#lb-sticky) und KI-Etikett an Galeriebildern.
  Tracking über window.lbTrack aus lb-basis.js: lb_sticky_warenkorb.
*/
(function () {
  if (window.__lbKaufbox) return;
  window.__lbKaufbox = true;

  function track(name, data) {
    if (typeof window.lbTrack === 'function') window.lbTrack(name, data || {});
  }
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // Warenkorb-Leiste: erscheint, sobald der echte Button oben aus dem Bild ist
  onReady(function () {
    var bar = document.getElementById('lb-sticky');
    if (!bar) return;
    var real = document.querySelector('.product-single__box .js-product-add');
    if (!real) { bar.remove(); return; }
    document.body.appendChild(bar);
    var btn = bar.querySelector('[data-lb-sticky-add]');

    function show(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('lb-sticky-on', on);
    }
    function sync() { btn.disabled = real.disabled; }

    var ticking = false;
    var shown = null;
    function check() {
      ticking = false;
      var on = real.offsetParent !== null && real.getBoundingClientRect().bottom < 0;
      if (on !== shown) { shown = on; show(on); }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
    }, { passive: true });
    window.addEventListener('resize', check);
    check();
    sync();
    new MutationObserver(sync).observe(real, { attributes: true, attributeFilter: ['disabled'] });
    btn.addEventListener('click', function () {
      if (real.disabled) return;
      track('lb_sticky_warenkorb', {});
      real.click();
    });
  });

  // KI-Etikett: Galeriebilder mit KI-Hinweis im Alt-Text bekommen ein Etikett (auch Slider-Kopien).
  // Vorlage des Etiketts: template[data-lb-ki-tpl] aus snippets/lb-basis.
  var KI_MERKMALE = ['ki-bild', 'ki-generiert', 'ai image', 'ai-generated', 'ai generated', 'immagine ia', 'generata con ia', 'generata con l’ia', "generata con l'ia"];
  function istKi(alt) {
    alt = (alt || '').toLowerCase();
    for (var i = 0; i < KI_MERKMALE.length; i++) { if (alt.indexOf(KI_MERKMALE[i]) !== -1) return true; }
    return false;
  }
  function kiGalerie() {
    var tpl = document.querySelector('template[data-lb-ki-tpl]');
    if (!tpl) return;
    document.querySelectorAll('.media-gallery__item').forEach(function (item) {
      if (item.querySelector('.lb-ki')) return;
      var img = item.querySelector('img.media-gallery__image') || item.querySelector('img');
      if (!img || !istKi(img.getAttribute('alt'))) return;
      (item.querySelector('.o-ratio__content') || item).appendChild(tpl.content.cloneNode(true));
    });
  }
  onReady(function () {
    kiGalerie();
    var gal = document.querySelector('.media-gallery');
    if (gal && 'MutationObserver' in window) new MutationObserver(kiGalerie).observe(gal, { childList: true, subtree: true });
  });
})();
